import DragResize from "./Drag";
import ScrollMonitor from "./ScrollMonitor";

declare const messagingApp: any;
export type DragMode = "horizontal" | "horizontal-snap" | "omnidirectional";

export default class Move extends DragResize {
    dm: DragMode;

    constructor() {
        super();
        this.className = "Move";
        this.cursor = "move";
    }

    static setDragable(dragMode: DragMode, el: HTMLElement) {
        const instance = new Move();
        instance.dm = dragMode;
        const pDoc = window.parent.document;

        const cntr = pDoc.getElementById(messagingApp.config.chatDivID);

        const dragHandleElem = el;
        instance.init(dragHandleElem, cntr);
    }

    static setClicked(el) {
        el[DragResize.INSTANCE_LABEL].uponClick();
    }

    setTop(top) {
        this.root.style.top = `${top}px`;
    }

    setLeft(left) {
        this.root.style.left = `${left}px`;
    }

    /*
     *Move.prototype.setDragBorder = function() {
     *    /** @type {number} * /
     *    var rootHeight = parseInt(this.root.style.height);
     *    /** @type {number} * /
     *    var rootWidth = parseInt(this.root.style.width);
     *    /** @type {number} * /
     *    var borderWidth = 7;
     *    this.obj.style.cursor = this.cursor;
     *    this.obj.style.borderStyle = "solid";
     *    this.obj.style.borderWidth = borderWidth + "px";
     *    this.obj.style.borderColor = DragResize.DEFAULT_BORDER_COLOR;
     *
     *    this.obj.style.height = rootHeight - borderWidth + "px";
     *    this.obj.style.width = rootWidth - borderWidth + "px";
     *};
     */

    whenDone() {
        if (this.dm === "horizontal-snap") {
            return;
        }

        this.root.style.left = `${String(this.pDraggerNow.X)}px`;
        this.root.style.top = `${String(this.pDraggerNow.Y)}px`;

        if (messagingApp.messageWindow?.moveStage) {
            const position = { X: this.pDraggerNow.X, Y: this.pDraggerNow.Y };
            messagingApp.messageWindow.moveStage(position.X, position.Y);
        }
    }

    /**
     * In horizontal and horizontal-snap modes, the chat should not move up or
     * down when dragging.
     */
    private isHorizontalOnlyDrag() {
        return this.dm === "horizontal" || this.dm === "horizontal-snap";
    }

    getDefaultMax() {
        const width = parseInt(window.getComputedStyle(this.root).width, 10);
        const height = parseInt(window.getComputedStyle(this.root).height, 10);

        return {
            X: ScrollMonitor.getScrollWidth() - width,
            Y: ScrollMonitor.getScrollHeight() - height - (this.isHorizontalOnlyDrag() ? parseInt(this.root.style.bottom, 10) : 0),
        };
    }

    getDefaultMin() {
        const height = parseInt(window.getComputedStyle(this.root).height, 10);
        const rootBottom = parseInt(this.root.style.bottom, 10);

        return {
            X: 0,
            Y: this.isHorizontalOnlyDrag() ? (ScrollMonitor.getScrollHeight() - rootBottom - height) : 0,
        };
    }
}
